import { render, staticRenderFns } from "./AvarageTimePaymentCard.vue?vue&type=template&id=61535e10&scoped=true"
import script from "./AvarageTimePaymentCard.vue?vue&type=script&lang=js"
export * from "./AvarageTimePaymentCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61535e10",
  null
  
)

export default component.exports